import { useState, useEffect } from 'react';
import { formatToTimeZone } from 'date-fns-timezone';

const useBusinessHours = () => {
  const [isBusinessHours, setIsBusinessHours] = useState(false);

  useEffect(() => {
    const [day, hour] = formatToTimeZone(new Date(), 'd H', {
      timeZone: 'America/New_York'
    }).split(' ');
    setIsBusinessHours(0 < day && day < 6 && 8 < hour && hour < 18);
  }, []);

  return isBusinessHours;
};

export default useBusinessHours;
